"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 14 14';

var Add = function Add() {
  return _react["default"].createElement("path", {
    d: "M12.8025,6.6225 L7.2375,6.6225 L7.2375,1.0575 C7.2375,0.7495 6.988,0.5 6.68,0.5 C6.372,0.5 6.1225,0.7495 6.1225,1.0575 L6.1225,6.6225 L0.5575,6.6225 C0.2495,6.6225 0,6.872 0,7.18 C0,7.488 0.2495,7.7375 0.5575,7.7375 L6.1225,7.7375 L6.1225,13.31 C6.1225,13.6175 6.372,13.8675 6.68,13.8675 C6.988,13.8675 7.2375,13.6175 7.2375,13.31 L7.2375,7.7375 L12.8025,7.7375 C13.1105,7.7375 13.36,7.488 13.36,7.18 C13.36,6.872 13.1105,6.6225 12.8025,6.6225"
  });
};

var _default = (0, _createSvgIcon["default"])(Add, {
  viewBox: viewBox
});

exports["default"] = _default;